import { Link } from 'react-router-dom';

interface LogoProps {
  size?: number;
  showText?: boolean;
  className?: string;
  linkTo?: string | null;
  color?: string;
  textColor?: string;
}

const Logo = ({
  size = 32,
  showText = true,
  className = '',
  linkTo = '/',
  color = '#16a34a',
  textColor = 'text-gray-900',
}: LogoProps) => {
  const logoContent = (
    <div className={`flex items-center ${className}`}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={showText ? 'mr-2' : ''}
      >
        <path d='M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z' />
        <text
          x='12'
          y='12.5'
          fontFamily='Arial, sans-serif'
          fontSize={size * 0.3125}
          fontWeight='900'
          fill={color}
          textAnchor='middle'
          stroke='none'
          dominantBaseline='central'
        >
          S
        </text>
      </svg>
      {showText && (
        <span className={`text-xl font-bold ${textColor}`}>Suremify</span>
      )}
    </div>
  );

  if (linkTo) {
    return (
      <Link
        to={linkTo}
        className='flex items-center transition-opacity hover:opacity-80'
      >
        {logoContent}
      </Link>
    );
  }

  return logoContent;
};

export default Logo;
